export const TEST_ID = {
  searchBar: 'searchBar',
  searchIcon: 'searchIcon',
  searchInput: 'searchInput',
};
